import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

const APP_NAME = "Pixel Cursor Cat";

function CatCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition((prev) => {
        const dx = e.clientX - prev.x;
        const dy = e.clientY - prev.y;
        return {
          x: prev.x + dx * 0.15,
          y: prev.y + dy * 0.15,
        };
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        left: position.x,
        top: position.y,
        pointerEvents: "none",
        zIndex: 9999,
        transform: "translate(-50%, -50%)",
        transition: "transform 0.1s ease-out",
        filter: "drop-shadow(2px 2px 0px rgba(0,0,0,0.2))",
      }}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="pixel cat"
      >
        <rect x="8" y="12" width="16" height="12" fill="#FFB6C1" />
        <rect x="6" y="8" width="4" height="6" fill="#FFB6C1" />
        <rect x="22" y="8" width="4" height="6" fill="#FFB6C1" />
        <rect x="10" y="16" width="2" height="2" fill="black" />
        <rect x="20" y="16" width="2" height="2" fill="black" />
        <rect x="15" y="20" width="2" height="2" fill="#FF69B4" />
      </svg>
    </div>
  );
}

function App() {
  return (
    <main
      style={{
        fontFamily: "system-ui, sans-serif",
        padding: "2rem",
        textAlign: "center",
        userSelect: "none",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fdf6e3",
        margin: 0,
      }}
    >
      <h1 style={{ color: "#d33682" }}>{APP_NAME}</h1>
      <p style={{ color: "#657b83" }}>A little pixel friend is following your cursor!</p>
      <CatCursor />
    </main>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
